<script lang="ts" setup>
  import WhatsAppIcon from '@/shared/components/icons/WhatsAppIcon.vue'
  import { WHATSAPP_URL } from './WhatsAppButton.constants'

  interface Props {
    href: string
  }
  interface Emits {
    (e: 'onClick'): void
  }
  withDefaults(defineProps<Props>(), {
    href: WHATSAPP_URL,
  })
  const emit = defineEmits<Emits>()
</script>

<template>
  <a
    :href="href"
    @click="emit('onClick')"
    class="whatsapp-button"
    target="_blank nofollow noopener"
  >
    <WhatsAppIcon />
    <slot>{{ $t('contact_us_popup.whatsapp.button') }}</slot>
  </a>
</template>

<style lang="scss" scoped>
  @import './WhatsAppButton';
</style>
